"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndCreateRelativeConfig = exports.validateAndCreateConfig = exports.createDateList = void 0;
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const offset_1 = require("../utils/offset");
const range_1 = require("../utils/range");
const createDateList = (recurringDateConfig) => {
    (0, common_1.finleyAssert)('type' in recurringDateConfig &&
        recurringDateConfig.type === 'calendarDate', 'Recurring date config type must be CalendarDate');
    const { startDate, endDate, period, cadence, offset } = recurringDateConfig;
    const startDateTime = luxon_1.DateTime.fromISO(startDate);
    const endDateTime = luxon_1.DateTime.fromISO(endDate);
    const dateList = [];
    let currentDateTime = startDateTime;
    // @jendevelops TODO: add support for setting inclusive/ exclusive on start date in config
    // eslint-disable-next-line no-restricted-syntax
    while (currentDateTime <= endDateTime) {
        const newDate = (0, offset_1.applyOffset)({
            offset: offset ?? { days: 0, dayUnit: 'calendarDay' },
            date: currentDateTime,
        });
        if ((0, range_1.isDateInRange)({ date: newDate, start: startDate, end: endDate })) {
            dateList.push(newDate);
        }
        currentDateTime = currentDateTime.plus({ [period]: cadence });
    }
    return dateList;
};
exports.createDateList = createDateList;
function validateAndCreateConfig(startDate, endDate, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment) {
    if (period === 'week') {
        return {
            config: null,
            error: { frequency: 'Frequency cannot be `week`, must be recurring.' },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const calendarDateConfig = {
        type: 'calendarDate',
        startDate,
        endDate,
        period,
        cadence,
        offset,
    };
    return { config: calendarDateConfig, error: {} };
}
exports.validateAndCreateConfig = validateAndCreateConfig;
function validateAndCreateRelativeConfig(startDateFormula, endDateFormula, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, offsetNonBusinessDayAdjustment) {
    if (period === 'week') {
        return {
            config: null,
            error: { frequency: 'Frequency cannot be `week`, must be recurring.' },
        };
    }
    const offset = offsetDayUnit === 'calendarDay'
        ? {
            dayUnit: offsetDayUnit,
            days: offsetDays,
            nonBusinessDayAdjustment: offsetNonBusinessDayAdjustment,
        }
        : {
            dayUnit: offsetDayUnit,
            days: offsetDays,
        };
    const calendarDateConfig = {
        type: 'calendarDate',
        period,
        cadence,
        offset,
    };
    return {
        config: {
            startDateFormula,
            endDateFormula,
            baseDateConfig: calendarDateConfig,
        },
        error: {},
    };
}
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
//# sourceMappingURL=calendarDate.js.map